import { Button, Typography } from "@mindlercare/ui-web";
import { useEffect, useRef, useState } from "react";
import { useInternalAuth } from "../AuthenticationProvider";
import { Spinner } from "../components/Spinner";
import { useTranslation } from "../hooks/useTranslation";
import styled from "@emotion/styled";

export const SignInWithBankIdOnSameDevice = () => {
  const { t } = useTranslation();
  const {
    resetState,
    setPendingStatus,
    onBankIdSignInStateChange,
    startBankIdSignIn,
    cancelSignInWithBankId,
  } = useInternalAuth();

  const [isPending, setIsPending] = useState(false);
  const [statusMessage, setStatusMessage] = useState<string | undefined>("");
  const ref = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const unsubscribe = onBankIdSignInStateChange(({ status, message }) => {
      switch (status) {
        case "pending":
          setStatusMessage(message);
          setIsPending(true);
          break;
        default:
          setIsPending(false);
          break;
      }
    });

    return () => {
      unsubscribe();

      if (ref.current) {
        clearInterval(ref.current);
        ref.current = null;
      }
    };
  }, [onBankIdSignInStateChange]);

  return isPending ? (
    <SSNPending
      message={statusMessage ?? ""}
      onCancel={() => {
        cancelSignInWithBankId();
        setIsPending(false);
        resetState();
      }}
    />
  ) : (
    <Button
      variant="primary"
      onClick={async () => {
        setPendingStatus();
        setIsPending(true);
        const { autoStartToken } = (await startBankIdSignIn()) ?? {};
        window.location.href = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
      }}
    >
      {t("LOGIN_WITH_BANKID_ON_THIS_DEVICE")}
    </Button>
  );
};

const SSNPending = ({
  message,
  onCancel,
}: {
  message: string;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Spinner />
      <Typography variant="h3" mt={24}>
        {message}
      </Typography>
      <Button variant="secondary-small" mt={24} onClick={onCancel}>
        {t("CANCEL")}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 100%;
  align-items: flex-start;
`;
